import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Logo } from "@/components/store/Logo";
import { toast } from "sonner";

export function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await login(email, password); toast("Welcome back ♡"); nav(loc.state?.from || "/account"); }
    catch (er) { toast.error(apiErr(er)); }
    setBusy(false);
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16">
      <div className="text-center mb-8"><Logo className="h-9 mx-auto" /><h1 className="font-serif text-3xl mt-5">Welcome Back</h1><p className="text-sharoa-muted text-sm mt-1">Sign in to your SHAROA account</p></div>
      <form onSubmit={submit} className="space-y-4">
        <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="w-full border border-sharoa-line px-4 py-3 text-sm outline-none focus:border-sharoa-rose" />
        <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="w-full border border-sharoa-line px-4 py-3 text-sm outline-none focus:border-sharoa-rose" />
        <button data-testid="login-submit" disabled={busy} className="w-full bg-sharoa-rose text-white text-xs uppercase tracking-widest py-4">{busy ? "Signing in…" : "Sign In"}</button>
      </form>
      <p className="text-center text-sm text-sharoa-muted mt-6">New to SHAROA? <Link to="/register" className="text-sharoa-rose sh-underline">Create Account</Link></p>
    </div>
  );
}

export function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", phone: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await register(f); toast("Welcome to SHAROA ♡"); nav("/account"); }
    catch (er) { toast.error(apiErr(er)); }
    setBusy(false);
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16">
      <div className="text-center mb-8"><Logo className="h-9 mx-auto" /><h1 className="font-serif text-3xl mt-5">Join SHAROA</h1><p className="text-sharoa-muted text-sm mt-1">Create your account ♡</p></div>
      <form onSubmit={submit} className="space-y-4">
        <input data-testid="register-name" required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Full Name" className="w-full border border-sharoa-line px-4 py-3 text-sm outline-none focus:border-sharoa-rose" />
        <input data-testid="register-email" type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="Email" className="w-full border border-sharoa-line px-4 py-3 text-sm outline-none focus:border-sharoa-rose" />
        <input data-testid="register-phone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} placeholder="Mobile (optional)" className="w-full border border-sharoa-line px-4 py-3 text-sm outline-none focus:border-sharoa-rose" />
        <input data-testid="register-password" type="password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} placeholder="Password" className="w-full border border-sharoa-line px-4 py-3 text-sm outline-none focus:border-sharoa-rose" />
        <button data-testid="register-submit" disabled={busy} className="w-full bg-sharoa-rose text-white text-xs uppercase tracking-widest py-4">{busy ? "Creating…" : "Create Account"}</button>
      </form>
      <p className="text-center text-sm text-sharoa-muted mt-6">Already have an account? <Link to="/login" className="text-sharoa-rose sh-underline">Sign In</Link></p>
    </div>
  );
}
